import { render, staticRenderFns } from "./VendorForm.vue?vue&type=template&id=09915bfc"
import script from "./VendorForm.vue?vue&type=script&lang=js"
export * from "./VendorForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports